"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getFederalRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _jurisdictions = require("../jurisdictions");

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _types = require("../../assets/types");

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _Rule = require("../Rule");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getFederalRulesList(idCounter) {
  return [{
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(2)',
    limitAggregateSingle: 4000,
    limitAggregateJoint: 8000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    description: 'Motor Vehicle (one)',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      return this.canTakeMoreExemptions() && type === _types.VEHICLE;
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(4)',
    limitAggregateSingle: 1700,
    limitAggregateJoint: 3400,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Jewelry',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && type === _types.PERSONAL && (subType === _subTypes.JEWELRY || subType === _subTypes.WEDDING_RINGS);
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(3)',
    limitAggregateSingle: 13400,
    limitAggregateJoint: 26800,
    // NOTE: The norm is that lawyers list all household goods together, not itemized even though that's the statute.
    // limitPerItem: 625,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Household goods, One computer, TV, VCR, and radio, Electronics, Antiques, Books, Musical instruments, Clothes, Wedding rings, Non-farm animals. Max $625 per item.',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.BOOK, _subTypes.MUSICAL_INSTRUMENT, _subTypes.CLOTHES, _subTypes.PERSONAL_ANIMALS, _subTypes.WEDDING_RINGS];
      return this.canTakeMoreExemptions() && type === _types.PERSONAL && (subType === _subTypes.HOUSEHOLD || validSubtypes.includes(subType) || this.isOnlyTVVCRradioOrComputer(asset) || this.matchesTypeSubrule(asset, _subTypes.ELECTRONICS, 675, 1350, 'TYPE') || this.matchesTypeSubrule(asset, _subTypes.ANTIQUE, 675, 1350, 'SUBTYPE'));
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(9)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Healthaids',
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(n)',
    limitAggregateSingle: 1362800,
    limitAggregateJoint: 2725600,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'IRAs or Roth IRAs',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && type === _types.FINANCIAL && subType === _subTypes.IRA;
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(10); 11 U.S.C. § 522(d)(12)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Retirement or pension accounts (incl. 401(k)s, 403(b)s, profit-sharing and money purchase plans, SEP and SIMPLE IRAs, and defined benefit plans)',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && type === _types.FINANCIAL && (subType === _subTypes.RETIREMENT_401K || subType === _subTypes.RETIREMENT_403B || subType === _subTypes.RETIREMENT_PLAN || subType === _subTypes.SEP || subType === _tertiaryTypes.SIMPLE_IRA || subType === _subTypes.PENSION_PLAN);
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(10)(D)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Family support (alimony & child support)',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && type === _types.FINANCIAL && (subType === _subTypes.CHILD_SUPPORT || subType === _subTypes.ALIMONY);
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(10)(A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Social security, unemployment compensation, local public assistance benefit',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var tertiarytype = _lodash["default"].get(asset, 'assetJSON.tertiarytype');

      return this.canTakeMoreExemptions() && type === _types.FINANCIAL && (tertiarytype === _tertiaryTypes.SOCIAL_SECURITY || tertiarytype === _tertiaryTypes.UNEMPLOYMENT_COMPENSATION || tertiarytype === _tertiaryTypes.LOCAL_PUBLIC_ASSISTANCE_BENEFIT);
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(10)(B)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Veterans\' benefits, Disability, illness, or unemployment benefit',
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.VETERANS_BENEFITS || tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS || tertiaryType === _tertiaryTypes.UNEMPLOYMENT_BENEFITS);
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. 522(d)(11)(A)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Crime victim\'s compensation ',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && type === _types.FINANCIAL && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. 522(d)(11)(B)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Wrongful death award for person you relied on for support',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && type === _types.FINANCIAL && subType === _subTypes.WRONGFUL_DEATH_AWARD;
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. 522(d)(11)(D)',
    limitAggregateSingle: 25150,
    limitAggregateJoint: 50300,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Personal injury compensation, not incl. pain and suffering',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && type === _types.FINANCIAL && subType === _subTypes.PERSONAL_INJURY_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. 522(d)(11)(E)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Loss of future earnings compensation',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && type === _types.FINANCIAL && subType === _subTypes.LOSS_OF_FUTURE_EARNINGS_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(7)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Unmatured life insurance policies',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && type === _types.FINANCIAL && tertiaryType === _tertiaryTypes.UNMATURED_TERM_INSURANCE_POLICY;
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(11)(C)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Life insurance payments for a person you depended on, which you need for support are both fully exempt',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && type === _types.FINANCIAL && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PAYMENTS_FOR_DEPENDEE;
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(7), 11 U.S.C. § 522(d)(8)',
    limitAggregateSingle: 13400,
    limitAggregateJoint: 26800,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Whole life insurance policy\'s surrender value',
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && type === _types.FINANCIAL && subType === _tertiaryTypes.WHOLE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(6)',
    limitAggregateSingle: 2525,
    limitAggregateJoint: 5050,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    description: 'Tools of Trade',
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.TOOLS_OF_TRADE;
    }
  }, {
    id: _Rule.WILDCARD_ID,
    type: _jurisdictions.FEDERAL,
    statuteName: '11 U.S.C. § 522(d)(5)',
    limitAggregateSingle: 13900,
    limitAggregateJoint: 27800,
    description: 'Wildcard',
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}